import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify'; // Restore react-toastify
// import { Quill } from 'react-quill'
import ReactGA from 'react-ga'; // Restore Google Analytics
import ReactPixel from 'react-facebook-pixel'; // Restore Facebook Pixel
// import quillEmoji from 'quill-emoji'
// import imageResize from 'quill-image-resize'
// import * as am4core from '@amcharts/amcharts4/core'
// import am4themes_animated from '@amcharts/amcharts4/themes/animated'
import { pdfjs } from 'react-pdf';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';
import ErrorBoundary from '@components/@core/ErrorBoundary';
import Loading from '@components/LoadingAnimation';
import AppActions from '~/actions/app';
import { loading, version } from '~/services/util';
import Dashboard from '~/views/Dashboard';
import NavigationService from '~/services/NavigationService';

// Compatibility layer for react-toastify v11 - add POSITION constants for legacy code
if (!toast.POSITION) {
    toast.POSITION = {
        TOP_LEFT: 'top-left',
        TOP_RIGHT: 'top-right',
        TOP_CENTER: 'top-center',
        BOTTOM_LEFT: 'bottom-left',
        BOTTOM_RIGHT: 'bottom-right',
        BOTTOM_CENTER: 'bottom-center'
    };
}

// Configure PDF.js worker for v10.x
pdfjs.GlobalWorkerOptions.workerSrc = new URL('pdfjs-dist/build/pdf.worker.min.mjs', import.meta.url).toString();

// Temporarily commented out to avoid errors
// am4core.useTheme(am4themes_animated)

// Quill.register({ 'modules/emoji-toolbar': quillEmoji.ToolbarEmoji }, true)
// Quill.register('modules/imageResize', imageResize)

const ROOT = () => {
    const navigate = useNavigate();
    const location = useLocation();
    
    // Initialize NavigationService for saga compatibility
    useEffect(() => {
        NavigationService.setNavigator(navigate, location);
    }, [navigate, location]);

    const appStatus = useSelector((state) => state.app.status);

    // Restore other status checks
    const devStatus = useSelector((state) => state.develop.status);
    const mngStatus = useSelector((state) => state.manage.status);
    const comStatus = useSelector((state) => state.community.status);
    const cmpStatus = useSelector((state) => state.company.status);
    const venStatus = useSelector((state) => state.vendor.status);
    const aversion = useSelector((state) => state.app.version);

    const _busy = loading(appStatus) || loading(devStatus) || loading(mngStatus) || loading(comStatus) || loading(cmpStatus) || loading(venStatus);

    const dispatch = useDispatch();

    const _handleReset = () => {
        dispatch(AppActions.refreshRequest());
    };

    const clearCache = () => {
        if ('caches' in window) {
            caches.keys().then((names) => {
                names.forEach((name) => {
                    caches.delete(name);
                });
            });
            window.location.reload(true);
        }
    };

    useEffect(() => {
        // Restore version check with toast notification
        if (aversion !== version()) {
            toast.success(
                `We've released new features.
          Login for the free upgrade!`,
                {
                    position: toast.POSITION.TOP_RIGHT,
                }
            );
            dispatch(AppActions.logoutRequest());
            clearCache();
        }
    }, [aversion, dispatch]);

    // Initialize analytics only once
    useEffect(() => {
        ReactGA.initialize('UA-2358990-2');
        ReactPixel.init('673408869393316');
        ReactGA.pageview(window?.location?.pathname);
        ReactPixel.pageView();
    }, []); // Empty dependency array ensures this runs only once

    return (
        <ErrorBoundary>
            <Dashboard />
            <Loading loading={_busy} onReset={_handleReset} />
        </ErrorBoundary>
    );
};

export default ROOT;
